import React from "react";
import PropTypes from "prop-types";
import ListCaption from "../List/ListCaption";

const CatCaption = (props) =>
    props.amount && props.amount > 0 ? (
        <ListCaption>
            {props.children} ({props.amount})
        </ListCaption>
    ) : null;

CatCaption.propTypes = {
    amount: PropTypes.number,
    children: PropTypes.any,
};

export default CatCaption;
